function ImageHolder({ image }: { image?: string }) {
  return (
    <div className="cht-overflow-hidden cht-rounded-[24px] cht-border cht-border-slate-200/80 cht-shadow-soft">
      <img
        src={image}
        alt="Visual showcase"
        className="cht-w-full cht-h-auto cht-max-h-[580px] cht-object-cover"
        style={{
          borderBottomRightRadius: "30%",
          borderTopLeftRadius: "30%",
          borderTopRightRadius: "60px",
        }}
      />
    </div>
  );
}

export default ImageHolder;
